import { render, staticRenderFns } from "./patternDetail.vue?vue&type=template&id=1c4a8b40"
import script from "./patternDetail.vue?vue&type=script&lang=js"
export * from "./patternDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports